module.exports = __webpack_public_path__ + "img/product_27.d0c8988.webp";